<template>
  <div :class="simple ? '' : 'search-bar'">
    <b-input-group v-if="simple">
      <input class="form-control" v-model="search" placeholder="キーワードで検索" @keyup.enter="triggerSearch">
      <b-input-group-append>
        <b-btn block variant="outline-white" @click="triggerSearch">
          <i class="fa fa-search"></i>
        </b-btn>
      </b-input-group-append>
    </b-input-group>
    <b-container v-else>
      <form @submit.prevent="triggerSearch">
        <b-form-row class="pt-3">
          <b-col cols="4" md="7" lg="2" xl="3" class="mb-3">
            <b-form-select v-model="type" v-if="categoryList.length > 0">
              <option value="">すべて</option>
              <option v-for="category in categoryList" :key="category.id" :value="category.slug">{{ category.text }}</option>
            </b-form-select>
          </b-col>
          <b-col class="mb-3">
            <input class="form-control" v-model="search" placeholder="キーワードで検索">
          </b-col>
          <b-col cols="8" md="7" lg="4" xl="4" class="mb-3">
            <b-form-row>
              <b-col cols="6">
                <date-pick v-model="from"
                  nextMonthCaption="次の月"
                  prevMonthCaption="前の月"
                  :weekdays="[
                    '月', '火', '水', '木',
                    '金', '土', '日'
                  ]"
                  :months="[
                    '1月', '2月', '3月', 
                    '4月', '5月', '6月', 
                    '7月', '8月', '9月', 
                    '10月', '11月', '12月', 
                  ]"
                :inputAttributes="{readonly: true, placeholder: '開催日から'}"
                :isDateDisabled="isPastDate"/>
              </b-col>
              <b-col cols="6">
                <date-pick v-model="upto"
                  nextMonthCaption="次の月"
                  prevMonthCaption="前の月"
                  :weekdays="[
                    '月', '火', '水', '木',
                    '金', '土', '日'
                  ]"
                  :months="[
                    '1月', '2月', '3月', 
                    '4月', '5月', '6月', 
                    '7月', '8月', '9月', 
                    '10月', '11月', '12月', 
                  ]"
                :inputAttributes="{readonly: true, placeholder: '開催日まで'}"
                :isDateDisabled="isPastDateFrom"/>
              </b-col>
            </b-form-row>
          </b-col>
          <b-col cols="4" md="5" lg="3" xl="2" class="mb-3">
            <b-btn block variant="outline-primary" class="px-1" @click="triggerSearch">
              <i class="fa fa-search mr-2"></i>検索する
            </b-btn>
          </b-col>
        </b-form-row>
      </form>
    </b-container>
  </div>
</template>

<script>
import Form from 'vform'

export default {
  props: {
    simple: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    search: '',
    from: '',
    upto: '',
    type: '',

    categoryQuery: new Form({
      query: {
        category: ''
      }
    }),
      
    categoryList: [],
  }),
  
  mounted() {
    this.getCategories()
  },

  methods: {
    getCategories() {
      this.categoryQuery.post('/api/book/category')
        .then(({ data }) => {
          this.categoryList = data
        });
    },

    triggerSearch() {
      this.$router.push({ 
        path: 'books/' + this.type, 
        query: { 
          search: this.search,
          from: this.from,
          upto: this.upto,
        }
      })
    },

    isPastDate(date) {
      const currentDate = new Date();
      if ( this.upto != null && this.upto.length > 0 ) {
        return date > (new Date(this.upto)) || date < currentDate.setDate(currentDate.getDate() - 1)
      } else {
        return date < currentDate.setDate(currentDate.getDate() - 1)
      }
    },

    isPastDateFrom(date) {
      const currentDate = new Date();
      if ( this.from != null && this.from.length > 0 ) {
        return date < (new Date(this.from)) || date < currentDate.setDate(currentDate.getDate() - 1)
      }
      return date < currentDate.setDate(currentDate.getDate() - 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Search.vue